/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EuVatVerificationRequestV1 } from '../models/eu-vat-verification-request-v-1';
import { VerificationResultResponseV1 } from '../models/verification-result-response-v-1';


/**
 * API to trigger EU VAT number verification with caching
 */
@Injectable({
  providedIn: 'root',
})
export class EuVatVerificationV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyEuVatV1
   */
  static readonly VerifyEuVatV1Path = '/v1/eu-vat-verification/{countryCode}';

  /**
   * Trigger EU VAT number verification with caching.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyEuVatV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEuVatV1$Response(params: {
    countryCode: string;

    /**
     * EU VAT verification request
     */
    body: EuVatVerificationRequestV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<VerificationResultResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, EuVatVerificationV1Service.VerifyEuVatV1Path, 'post');
    if (params) {
      rb.path('countryCode', params.countryCode, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VerificationResultResponseV1>;
      })
    );
  }

  /**
   * Trigger EU VAT number verification with caching.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyEuVatV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyEuVatV1(params: {
    countryCode: string;

    /**
     * EU VAT verification request
     */
    body: EuVatVerificationRequestV1
  },
  context?: HttpContext

): Observable<VerificationResultResponseV1> {

    return this.verifyEuVatV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<VerificationResultResponseV1>) => r.body as VerificationResultResponseV1)
    );
  }

}
